export default __webpack_public_path__ + "static/media/enabled.c25c6dfb.svg";